module.exports = __webpack_public_path__ + "bh.svg?6d94e1984f74d9c9d3470e01080d5506";